import { faClock, faEllipsisVertical } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DateTime } from "luxon";
import { Dispatch, FC, SetStateAction } from "react";
import { Col, Dropdown, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import PaginateCard from "./PaginateCard";
import Note from "@/interfaces/Note";
import { IFilters, IMeta } from "@/interfaces/Fetch";

export interface NoteCardProps {
  data?: Note[];
  meta?: IMeta;
  filters: IFilters;
  setFilters: Dispatch<SetStateAction<IFilters>>;
  onRemove: (id: string) => void;
  onEdit?: (id: string, message: string) => void;
}

const NotesCard: FC<NoteCardProps> = ({
  data = [],
  meta,
  filters,
  setFilters,
  onRemove,
  onEdit,
}) => {
  return (
    <PaginateCard filters={filters} setFilters={setFilters} meta={meta}>
      {data.map(({ id, message, createdAt, author, authorId }, index) => (
        <div
          key={index}
          className="bg-white dark__bg-1100 p-x1 rounded-3 shadow-sm"
        >
          <Row className="flex-between-center">
            <Col xs={10}>
              <p className="w-lg-75 w-xl-100 w-xxl-75 mb-0 border-bottom border-md-0 border-xl-bottom border-xxl-0 mb-x1 mb-md-2 mb-xl-x1 mb-xxl-3 pb-x1 pb-md-0 pb-xl-x1 pb-xxl-0 border-200 border-xl-200">
                {message}
              </p>
            </Col>
            <Col xs={2} className="d-flex justify-content-end">
              <Dropdown
                align="end"
                className="btn-reveal-trigger d-inline-block"
              >
                <Dropdown.Toggle split variant="nolina-default" size="sm">
                  <FontAwesomeIcon
                    icon={faEllipsisVertical}
                    className="fs--2"
                  />
                </Dropdown.Toggle>
                <Dropdown.Menu className="border py-0">
                  <div className="py-2">
                    {onEdit && (
                      <Dropdown.Item onClick={() => onEdit(id, message)}>
                        Modifier
                      </Dropdown.Item>
                    )}
                    <Dropdown.Item
                      className="text-danger"
                      onClick={() => onRemove(id)}
                    >
                      Supprimer
                    </Dropdown.Item>
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            </Col>
          </Row>
          <h6 className="mb-0 mt-2">
            <FontAwesomeIcon icon={faClock} className="text-primary me-2" />
            <span className="text-600">
              {DateTime.fromISO(createdAt)
                .setLocale("fr")
                .toFormat("dd LLL yyyy")}
            </span>
            <span className="text-500"> à </span>
            <span className="text-600">
              {DateTime.fromISO(createdAt).setLocale("fr").toFormat("HH:mm")}
            </span>
            <span className="text-500"> par </span>
            {author ? (
              <Link to={`/users/${authorId}`} className="text-600">
                {author.fullname}
              </Link>
            ) : (
              <span className="text-600">Inconnu</span>
            )}
          </h6>
        </div>
      ))}
    </PaginateCard>
  );
};

export default NotesCard;
